<template>
  <div id="footer" class="container-fluid bk">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="logo图" />
    </div>
    <div
      class="copy"
      style="
        margin-top: 1rem;
        margin-right: 1rem;
        height: 1rem;
        line-height: 1rem;
        font-size: 12px;
      "
    >
      Copyright © 2023.杭州点一个网络科技有限公司 All rights reserved.
      <span
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
          margin-left: 1rem;
          color: fff;
        "
        >经营许可证编号：浙B2--20240008</span
      ><a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="margin-left: 1rem; color: fff"
        >浙ICP备2023015852</a
      ><a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33018202000632"
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
          margin-left: 1rem;
          color: fff;
        "
        ><img
          src="@/assets/images/ga.png"
          style="float: left; width: 16px"
        />浙公网安备 33018202000632号</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgb(79, 62, 43);
  overflow: hidden;
  text-align: center;
}

/* .bk {
  background-image: url(../assets/images/background2740d2.jpg);
  background-size: auto 100%;
  background-repeat: no-repeat;
} */
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
  display: flex;
  justify-content: center;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue